<template>
    <v-app id="inspire" full-width>
        <snackbar-component ref="snackbar"></snackbar-component>
        <flashed-message-handler/>
        <confirm-dialog ref="confirm"></confirm-dialog>
        <div class="cloaked-alert tw-bg-primary tw-shadow-xl" v-show="$page.is_impersonating">
            <div class="tw-text-xs tw-font-light">You are cloaked</div>
            <button class="tw-text-xs text-link underline hover:tw-cursor-pointer" @click="leaveCloak">Uncloak</button>
        </div>
        <v-navigation-drawer
            v-model="drawer"
            disable-resize-watcher
            width="100%"
            app
            class="navigation-drawer-styling"
        >
            <div class="tw-flex tw-m-4">
                <v-btn dark @click="drawer = !drawer" class="main-btn tw-mb-7">
                    <v-icon>
                        mdi-close
                    </v-icon>
                    CLOSE
                </v-btn>

                <v-spacer></v-spacer>

                <v-btn icon color="black">
                    <svg xmlns="http://www.w3.org/2000/svg" width="26.827" height="26.922" viewBox="0 0 26.827 26.922">
                        <g id="Group_4500" data-name="Group 4500" transform="translate(11734.213 12196.213)">
                            <g id="Group_4501" data-name="Group 4501" transform="translate(-11734.213 -12196.213)">
                                <g id="Button" transform="translate(21.87 21.87) rotate(180)">
                                    <g id="Ellipse_1" data-name="Ellipse 1" transform="translate(0 0)" fill="none" stroke="#231f20" stroke-width="2">
                                        <circle cx="10.935" cy="10.935" r="10.935" stroke="none"/>
                                        <circle cx="10.935" cy="10.935" r="9.935" fill="none"/>
                                    </g>
                                </g>
                                <line id="Line_176" data-name="Line 176" x2="7.848" y2="7.946" transform="translate(18.268 18.274)" fill="none" stroke="#231f20" stroke-width="2"/>
                            </g>
                        </g>
                    </svg>
                </v-btn>
            </div>

            <div class="tw-flex tw-flex-col tw-gap-2 mobile-nav-styling" @click="drawer = !drawer">
                <smart-nav v-if="!$vuetify.breakpoint.mdAndUp" endpoint="mymenusystem" name="top" ref="navtop"/>
            </div>
        </v-navigation-drawer>
        <auth-bar v-model="show_login" ref="auth_bar" />
        <v-main>
            <div
                class="tw-pb-8 tw-px-4 md:tw-px-10 tw-mt-20 md:tw-mt-28"
            >
                <div>
                    <!-- Desktop Version -->
                    <v-app-bar
                        fixed
                        class="d-none d-md-block nav-bar-styling d-print-none"
                        hide-on-scroll
                    >
                        <img src="/img/logo.svg" alt="Iatse667 Logo" @click="goToHome" class="tw-cursor-pointer" style="width:45px; height:43px;">

                        <v-spacer></v-spacer>

                        <smart-nav v-if="$vuetify.breakpoint.mdAndUp" endpoint="mymenusystem" name="top" ref="navtop"/>

                        <v-spacer></v-spacer>

<!--                        <v-icon class="tw-mr-3"-->
<!--                            color="black"-->
<!--                        >mdi-magnify</v-icon>-->

                            <v-btn
                                @click="toggleLogin"
                                class="main-btn"
                                v-if="$page.user === null"
                            >
                                LOGIN
                                <v-icon class="tw-pl-1">
                                    mdi-account
                                </v-icon>
                            </v-btn>
                        <v-menu
                        bottom
                        offset-y
                        v-else
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    class="main-btn"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    Account
                                    <v-icon>
                                        mdi-account
                                    </v-icon>
                                </v-btn>
                            </template>
                            <div class="tw-flex tw-flex-col tw-p-4 tw-gap-4 tw-bg-white">
                                <a class="tw-flex tw-flex-row tw-items-center tw-gap-2" @click="goToProfile">
                                    <span class="tw-text-md sm:tw-text-xs tw-uppercase text-link" >View Profile</span>
                                </a>
                                <a class="tw-flex tw-flex-row tw-items-center tw-gap-2" @click="logout">
                                    <span class="tw-text-md sm:tw-text-xs tw-uppercase text-link" >Logout</span>
                                </a>
                            </div>

                        </v-menu>


                    </v-app-bar>

                    <!-- Mobile Version -->
                    <v-app-bar
                        fixed
                        class="flex d-md-none nav-bar-styling d-print-none">
                        <v-btn @click="drawer = !drawer" class="main-btn">
                            <v-icon>
                                mdi-menu
                            </v-icon>
                            MENU
                        </v-btn>

                        <v-spacer></v-spacer>

                        <img src="/img/logo.svg" alt="Iatse667 Logo" @click="goToHome" style="width:45px; height:43px;">

                        <v-spacer></v-spacer>

                            <v-btn
                                @click="toggleLogin"
                                class="main-btn"
                                v-if="$page.user === null"
                            >
                                LOGIN
                                <v-icon>
                                    mdi-account
                                </v-icon>
                            </v-btn>
                            <v-btn
                                @click="goToProfile"
                                class="main-btn"
                                v-else
                            >
                                PROFILE
                                <v-icon>
                                    mdi-account
                                </v-icon>
                            </v-btn>

                        </v-app-bar>
                    </div>
                <div>
                   <slot></slot>
                </div>
            </div>
        </v-main>

        <v-footer padless class="d-print-none">
            <div class="footer-styling tw-flex tw-flex-col tw-w-full tw-gap-1 tw-pt-4 tw-px-4 tw-pb-2">
                <div class="tw-flex tw-flex-col sm:tw-flex-row md:tw-gap-10 xl:tw-gap-20">
                    <!-- Images & Contact -->
                    <div class="tw-flex tw-flex-row lg:tw-justify-between tw-w-full">
                        <!-- Images -->
                        <div class="tw-flex tw-flex-col sm:tw-flex-row">
                            <div class="tw-w-1/2 md:tw-w-1/6 tw-mr-14">
                                <img src="/img/logo-white.svg" alt="Iatse667 Logo" @click="goToHome" class="tw-cursor-pointer" >
                            </div>
                            <div class="tw-w-3/4 md:tw-w-1/4">
                                <a href="https://www.iatse667-669healthplan.com" target="_blank">
                                    <img src="/img/LifeInMOTION_logo.png" alt="Life in Motion Logo" class="tw-mt-10 md:tw-mt-1">
                                </a>
                            </div>
                        </div>
                        <!-- Contact -->
                        <div class="tw-flex tw-flex-col tw-text-white tw-gap-3 sm:tw-gap-1">
                            <div class="h7 tw-font-normal pb-1 md:pb-5">CONTACT</div>
                            <span class="h7 tw-font-light">IATSE LOCAL 667</span>
                            <span class="h7 tw-font-light"><a href="tel:4163680072">416-368-0072</a></span>
                            <span class="h7 tw-font-light">TOLL-FREE</span>
                            <span class="h7 tw-font-light"><a href="tel:18773681667">1-877-368-1667</a></span>
                            <span class="h7 tw-font-light">
                                <a href="mailto:CAMERA@IATSE667.COM">
                                    CAMERA@IATSE667.COM
                                </a>
                            </span>
                        </div>

                    </div>
                    <hr class="tw-my-6 tw-flex sm:tw-hidden tw-text-white tw-border-white">
                    <!-- About us & follow -->
                    <div class="tw-flex tw-flex-row md:tw-justify-end tw-gap-6 md:tw-gap-10 xl:tw-gap-16 tw-pr-14">

                        <!-- WEBSITES -->
                        <div class="tw-flex tw-flex-col tw-text-white tw-gap-3 sm:tw-gap-1">
                            <div class="h7 tw-font-normal pb-1 md:pb-5">WEBSITES</div>
                            <span class="h7 tw-font-light"><a href="https://www.ia667dp.com/" target="_blank" >667 DP</a></span>
                            <span class="h7 tw-font-light"><a href="https://ia667stills.com/" target="_blank" >667 STILLS</a></span>
                            <span class="h7 tw-font-light"><a href="https://iatse671.wordpress.com/" target="_blank" >IATSE 671</a></span>
                            <span class="h7 tw-font-light"><a href="https://canada.iatse.net/" target="_blank">IATSE CANADA</a></span>
                            <span class="h7 tw-font-light"><a href="https://iatse.net/" target="_blank">IATSE INTL</a></span>
                        </div>

                        <!-- About Us -->
                        <div class="tw-flex tw-flex-col tw-w-40 tw-text-white tw-gap-4 sm:tw-gap-1">
                            <div class="tw-hidden md:tw-flex h7 tw-font-normal tw-pb-0 sm:tw-pb-3 ">ABOUT</div>
                            <inertia-link :href="route('about-us.index')" class="h7 tw-font-light">ABOUT US</inertia-link>
                            <inertia-link :href="route('how-to-join.index')" class="h7 tw-font-light">HOW TO JOIN</inertia-link>
                            <inertia-link :href="route('health-safety.index')" class="h7 tw-font-light">HEALTH & SAFETY</inertia-link>
                            <inertia-link :href="route('news-and-events.index')" class="h7 tw-font-light">NEWS & EVENTS</inertia-link>
                        </div>
                        <!-- Follow -->
                        <div class="tw-flex tw-flex-col tw-w-32 tw-pl-6 md:tw-pl-0 tw-text-white tw-gap-6 sm:tw-gap-1">
                            <div class="tw-hidden md:tw-flex h7 tw-font-normal tw-pb-0 sm:tw-pb-3">FOLLOW</div>
                            <inertia-link href="https://www.facebook.com/people/International-Cinematographers-Guild-IATSE-Local-667/100064352152649/" class="h7 font-light">FACEBOOK</inertia-link>
                            <inertia-link href="https://twitter.com/IATSE667" class="h7 font-light">X <span class="tw-text-xs">(fka twitter)</span></inertia-link>
                            <inertia-link href="https://www.instagram.com/iatselocal667" class="h7 font-light">INSTAGRAM</inertia-link>
                            <inertia-link href="https://ca.linkedin.com/company/iatse-local-667" target="_blank" class="h7 tw-font-light">LinkedIn</inertia-link>
                        </div>
                    </div>
                </div>
                <div class="tw-flex tw-flex-row tw-gap-4 tw-pt-2 tw-mt-0 lg:tw-mt-8 tw-border-0 md:tw-border-t tw-border-white">
                    <div>&copy;{{ new Date().getFullYear() }}</div>
                    <div @click="dialog_privacy = true" class="tw-cursor-pointer text-link"><a href="#">Privacy Policy</a></div>
                    <v-dialog
                        v-model="dialog_privacy"
                        scrollable
                        max-width="800px"
                    >
                        <div class="tw-flex tw-flex-col  tw-text-black">
                            <v-btn @click="dialog_privacy = false" class="main-btn tw-w-36 tw-my-3 tw-mx-auto">
                                Close
                            </v-btn>
                            <privacyPolicy></privacyPolicy>
                        </div>
                    </v-dialog>
                    <div class="tw-cursor-pointer text-link" @click="dialog_disclaimer = true" ><a href="#">Disclaimer</a></div>
                    <v-dialog
                        v-model="dialog_disclaimer"
                        scrollable
                        max-width="800px"
                    >
                        <div class="tw-flex tw-flex-col tw-text-center tw-text-black">
                            <v-btn @click="dialog_disclaimer = false" class="main-btn tw-w-36 tw-mx-auto tw-my-3">
                                Close
                            </v-btn>
                            <h2 class="tw-mt-2 tw-mb-5">Disclaimer</h2>
                            <div class="tw-px-5 lg:tw-px-14 tw-pt-5">
                                This web site provides answers to some of the general questions you may have about I.A.T.S.E., Local 667 ("I.A.T.S.E. 667"). The access of use of this website by third parties does not create or confer any contractual or other rights to such third parties. I.A.T.S.E. 667 does not warrant the quality, accuracy or completeness of any information or services made available on this website. Such information and services are provided 'as is' without warranty or condition of any kind. This website may include inaccuracies or typographical errors.
                                I.A.T.S.E. 667 does not exert responsibility, editorial or other control over the contents of the links to other internet sites or any postings by a third party. I.A.T.S.E. 667 disclaims any and all liability for any claims or damages that may result from any postings by third parties. I.A.T.S.E. 667 disclaims any and all liability for injury and/or other damages that result from an individual using any information discussed or provided on this website.
                                Any third party accessing this website agrees, by virtue of such access, to indemnify the webmaster, I.A.T.S.E. 667 and the service provider for any damages, costs and expenses, including reasonable legal fees, that result or arise from the activities of any such third party on this website.
                                Reference to third party information, products or services at this or any linked website is not an expressed or implied endorsement by I.A.T.S.E. 667.
                            </div>
                        </div>
                    </v-dialog>
                    <v-spacer></v-spacer>
                    <span class="tw-font-light">Web Development and Hosting by <a href="https://www.directimpactsolutions.com/" target="_blank">Direct Impact Solutions</a></span>
                </div>
            </div>
        </v-footer>
        <portal-target name="modal" multiple></portal-target>

    </v-app>
</template>

<script>
import JetApplicationLogo from '@/Jetstream/ApplicationLogo'
import JetApplicationMark from '@/Jetstream/ApplicationMark'
import JetDropdown from '@/Jetstream/Dropdown'
import JetDropdownLink from '@/Jetstream/DropdownLink'
import JetNavLink from '@/Jetstream/NavLink'
import JetResponsiveNavLink from '@/Jetstream/ResponsiveNavLink'
import SnackbarComponent from "@/Generic/SnackbarComponent";
import ConfirmDialog from "@/Generic/ConfirmDialog";
import SmartNav from "@/SmartNav/SmartNav";
import {Inertia} from "@inertiajs/inertia";
import AuthBar from "@/Generic/AuthBar.vue";
import PrivacyPolicy from "@/Generic/PrivacyPolicy";
import FlashedMessageHandler from "@/Generic/FlashedMessageHandler.vue";

export default {
    components: {
        FlashedMessageHandler,
        PrivacyPolicy,
        AuthBar,
        SmartNav,
        JetApplicationLogo,
        JetApplicationMark,
        JetDropdown,
        JetDropdownLink,
        JetNavLink,
        JetResponsiveNavLink,
        SnackbarComponent,
        ConfirmDialog,
    },

    data() {
        return {
            cards: ['Today', 'Yesterday'],
            drawer: false,
            show_login: false,
            removeInertiaStartEventListener: null,
            dialog_privacy: false,
            dialog_disclaimer: false,
        }
    },

    computed: {
        path() {
            return window.location.pathname
        },
    },

    methods: {
        showDisclaimer() {
            this.showDisclaimerDialog = true
        },
        leaveCloak() {
            this.$inertia.visit(route('user.leave-cloak'), {
                onFinish: visit => {
                    location.reload()   // This will make sure the top-level nav gets reloaded as well.
                }
            })
        },
        logout() {
            axios.post(route('logout').url()).then(response => {
                window.location = '/';
            })
        },
        goToHome() {
            this.$inertia.visit(route('home'))
        },
        goToLogin() {
            //this.$inertia.visit(route('login')) // Removed this one as it open a popup to login page and we are not redirected on the parent when logged in.
            window.location = route('login')
        },
        toggleLogin() {
            this.show_login = !this.show_login
        },
        toggleLogout() {
            Inertia.post(route('logout'));
        },
        goToProfile() {
            Inertia.visit(route('home'));
        },
        handleWelcome() {
            const url_params = new URLSearchParams(window.location.search)
            let show_welcome = url_params.get('welcome') === 'true'
            if (show_welcome) {
                this.show_login = true
                this.$refs?.auth_bar?.changeView("AuthBarWelcome")
            }
        }

    },

    mounted() {
        this.$root.snackbar = this.$refs.snackbar
        this.$root.confirm = this.$refs.confirm
        this.$root.navtop = this.$refs.navtop

        this.handleWelcome()
    },
}
</script>
<style scoped>
    html,body, .v-application, .v-app, .font-change {
        font-family: ABCFavorit, system-ui, sans-serif !important;
    }
    .cloaked-alert {
        display: block;
        position:fixed !important;
        z-index: 10;
        bottom: 35px;
        right: 25px;
        padding: 10px 20px;
    }
</style>
